export default __webpack_public_path__ + "static/media/bg8.6d56eb2d.jpg";